module.exports = __webpack_public_path__ + "static/media/flexibility_trap.64c03497.png";